// extracted by mini-css-extract-plugin
export default {"content":"EditCode_content__xFx9Q","button":"EditCode_button__PXBuW"};